import axios from 'axios'
import { pageLoader } from "@/stores/pageLoader";

const api = axios.create({
  baseURL: 'https://dash.smartimza.com/api',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})
api.interceptors.request.use((config) => {
    if (!config.hideLoader) {
        pageLoader.start();
    }

    return config;
});


api.interceptors.response.use(
    (response) => {
        if (!response.config.hideLoader) {
            pageLoader.stop();
        }

        return response;
    },
    (error) => {
        if (!error.config?.hideLoader) {
            pageLoader.stop();
        }

        return Promise.reject(error);
    }
);
export default api;

//slider
export const getSliders = async () => {
  try {
    const response = await api.get('/sliders')
    return response.data.data
  } catch (error) {
    console.error('Failed to fetch sliders', error)
    throw error
  }
}

//reels
export const getReels = async () => {
  try {
    const response = await api.get('/reels')
    return response.data.data
  } catch (error) {
    console.error('Failed to fetch reels', error)
    throw error
  }
}

//properties
export const getFeaturedProperties = async (locale = 'en') => {
  try {
    const response = await api.get('/featured-properties', {
      headers: {
        'locale': locale,
      },
    })

    return response.data.data
  } catch (error) {
    console.error('Failed to fetch featured properties', error)
    throw error
  }
}
export const getProperties = async (locale = 'en', page = 1) => {
  try {
    const response = await api.get(`/properties?page=${page}`, {
      headers: {
        'locale': locale,
      },
    })
    return response.data
    
    
  } catch (error) {
    console.error('Failed to fetch properties', error)
    throw error
  }
}

export const getPropertyBySlug = async (slug, locale = 'en') => {
  try {
    const res = await api.get(`/property/${slug}`, {
      headers: { locale }
    })

    return res.data.data
  } catch (error) {
    console.error('Failed to fetch property detail', error)
    throw error
  }
}

//projects
export const getLatestProjects = async (locale = 'en') => {
  try {
    const response = await api.get('/latest-projects', {
      headers: {
        'locale': locale,
      },
    })

    return response.data.data
  } catch (error) {
    console.error('Failed to fetch latest projects', error)
    throw error
  }
}

export const getProjects = async (locale = 'en', page = 1) => {
  try {
    const response = await api.get(`/projects?page=${page}`, {
      headers: {
        'locale': locale,
      },
    })
    return response.data
    
    
  } catch (error) {
    console.error('Failed to fetch projects', error)
    throw error
  }
}

export const getProjectBySlug = async (slug, locale = 'en') => {
  try {
    const res = await api.get(`/project/${slug}`, {
      headers: { locale }
    })

    return res.data.data
  } catch (error) {
    console.error('Failed to fetch project detail', error)
    throw error
  }
}

export const getRealCategories = async (locale = 'en') => {
  try {
    const res = await api.get(`/real-categories`, {
      headers: { locale }
    })

    return res.data.data
  } catch (error) {
    console.error('Failed to fetch real categories', error)
    throw error
  }
}

//about company
export const getAboutCompany = async (locale = 'en') => {
  try {
    const response = await api.get('/about', {
      headers: {
        'locale': locale,
      },
    })
    return response.data.data
    
    
  } catch (error) {
    console.error('Failed to fetch about info', error)
    throw error
  }
}

//cities
export const getCities = async (locale = 'en') => {
  try {
    const response = await api.get('/cities', {
      headers: {
        'locale': locale,
      },
    })
    return response.data.data
    
    
  } catch (error) {
    console.error('Failed to fetch cities', error)
    throw error
  }
}

export const getPropertiesByCitySlug = async (
  slug,
  locale = 'en',
  page = 1
) => {
  try {
    const res = await api.get(`/city/${slug}`, {
      headers: { locale },
      params: { page }
    })

    return res.data
  } catch (error) {
    console.error('Failed to fetch city properties', error)
    throw error
  }
}


//blogs
export const getMainBlogs = async (locale = 'en') => {
  try {
    const response = await api.get('/main-blog', {
      headers: {
        'locale': locale,
      },
    })
    return response.data.data
    
    
  } catch (error) {
    console.error('Failed to fetch main blogs', error)
    throw error
  }
}

export const getBlogs = async (locale = 'en', page = 1) => {
  try {
    const response = await api.get(`/blogs?page=${page}`, {
      headers: {
        'locale': locale,
      },
    })
    return response.data    
  } catch (error) {
    console.error('Failed to fetch blogs', error)
    throw error
  }
}

export const getBlogBySlug = async (slug, locale = 'en') => {
  try {
    const res = await api.get(`/blog/${slug}`, {
      headers: { locale }
    })

    return res.data
  } catch (error) {
    console.error('Failed to fetch blog detail', error)
    throw error
  }
}

export const getRelatedBlogs = async (id, locale = 'en') => {
  try {
    const res = await api.get(`/blog/${id}/related`, {
      headers: { locale }
    })

    return res.data.data
  } catch (error) {
    console.error('Failed to fetch related blogs', error)
    throw error
  }
}

export const getPopularBlogCategories = async (locale = 'en') => {
  try {
    const response = await api.get('/popular-categories', {
      headers: {
        'locale': locale,
      },
    })
    return response.data.data
    
    
  } catch (error) {
    console.error('Failed to fetch popular blog categories', error)
    throw error
  }
}

export const getPopularTags = async (locale = 'en') => {
  try {
    const response = await api.get('/tags', {
      headers: {
        'locale': locale,
      },
    })
    return response.data.data
    
    
  } catch (error) {
    console.error('Failed to fetch popular tags', error)
    throw error
  }
}
//Quick Access
export const getQuickAccessCategories = async (locale = 'en') => {
  try {
    const response = await api.get('/access/categories', {
      headers: {
        'locale': locale,
      },
    })
    return response.data.data
    
    
  } catch (error) {
    console.error('Failed to fetch access categories', error)
    throw error
  }
}

export const getAccessByCategory = async (locale = 'en', id) => {
  try {
    const response = await api.get(`/access-categories/${id}/accesses`, {
      headers: {
        locale,
      },
    })

    return response.data.data
  } catch (error) {
    console.error('Failed to fetch accesses', error)
    throw error
  }
}

//Service
export const getServices = async (locale = 'en', page = 1) => {
  try {
    const response = await api.get(`/services?page=${page}`, {
      headers: {
        'locale': locale,
      },
    })
    return response.data
    
    
  } catch (error) {
    console.error('Failed to fetch services', error)
    throw error
  }
}

export const getServiceBySlug = async (slug, locale = 'en') => {
  try {
    const res = await api.get(`/service/${slug}`, {
      headers: { locale }
    })

    return res.data.data
  } catch (error) {
    console.error('Failed to fetch service detail', error)
    throw error
  }
}

export const getRelatedServices = async (id, locale = 'en') => {
  try {
    const res = await api.get(`/service/${id}/related`, {
      headers: { locale }
    })

    return res.data.data
  } catch (error) {
    console.error('Failed to fetch related services', error)
    throw error
  }
}
//Subscribe
export const subscribe = async (email, locale = 'en') => {
  try {
    const response = await api.post(
      '/subscribe',
      {
        email
      },
      {
        headers: {
          locale
        }
      }
    )

    return response.data
  } catch (error) {
    console.error('Subscribe failed', error)
    throw error
  }
}

//Seo Setting
export const getSeoInfo = async (locale = 'en') => {
  try {
    const response = await api.get('/seo-settings', {
      headers: {
        'locale': locale,
      },
    })

    return response.data.data
  } catch (error) {
    console.error('Failed to fetch Seo Info', error)
    throw error
  }
}

//Contact
export const storeContact = (data,locale = 'en') =>
    api.post("/contacts", data, {
        hideLoader: true,
        headers: {
          'locale': locale,
        },
    }
    );

//Pages
export const getPage = async (type, locale = 'en') => {
  const response = await api.get(`/pages/${type}`, {
    headers: {
      locale,
    },
  })

  return response.data.data
}

export const getPageBySlug = async (slug, locale='en') => {
  try {

      const response = await api.get(`/pages/slug/${slug}`, {
          headers:{
              locale
          }
      })

      return response.data.data

  } catch(error){

      console.error('Failed to fetch page', error)
      throw error
  }
}

//Main Form
export const storeMainContact = (data,locale = 'en') =>
    api.post("/main-contact", data, {
        hideLoader: true,
        headers: {
          'locale': locale,
        },
    }
    );

//Faqs
export const getFaqCategories = async (locale = 'en') => {
  try {
    const response = await api.get('/faq-categories', {
        headers:{
            locale
        }
    })
    return response.data.data
  } catch (error) {
    console.error('Failed to fetch faq categories', error)
    throw error
  }
}

export const getFaqsByCategoryId = async (categoryId ,locale = 'en') => {
  try {
    const response = await api.get(`/category/${categoryId}`, {
        headers:{
            locale
        }
    })
    return response.data.data
  } catch (error) {
    console.error('Failed to fetch faqs', error)
    throw error
  }
}

//Types
export const getTypes = async (locale = 'en') => {
  try {
    const response = await api.get('/types', {
        headers:{
            locale
        }
    })
    return response.data.data
  } catch (error) {
    console.error('Failed to fetch types', error)
    throw error
  }
}

//Currency
export const getCurrencies = async (locale = 'en') => {
  try {
    const response = await api.get('/currencies', {
        headers:{
            locale
        }
    })
    return response.data.data
  } catch (error) {
    console.error('Failed to fetch currencies', error)
    throw error
  }
}

//Search
export const search = (filters,locale = 'en') =>
  api.post("/search", filters, {
      hideLoader: true,
      headers: {
        'locale': locale,
      },
  }
);

//Turkish Citizenship
export const getTurkeyFaqs = async (locale = 'en', page = 1) => {
  try {
    const response = await api.get('/Turkey/faqs', {
        headers:{
            locale
        },
        params:{
            page
        }
    })
    return response.data
  } catch (error) {
    console.error('Failed to fetch Turkey Faqs', error)
    throw error
  }
}

export const getTurkeyServices = async (locale = 'en') => {
  try {
    const response = await api.get('/Turkey/services', {
        headers:{
            locale
        }
    })
    return response.data.data
  } catch (error) {
    console.error('Failed to fetch Turkey Services', error)
    throw error
  }
}

export const getTurkeyBlogs = async (locale = 'en') => {
  try {
    const response = await api.get('/Turkey/blogs', {
        headers:{
            locale
        }
    })
    return response.data.data
  } catch (error) {
    console.error('Failed to fetch Turkey blogs', error)
    throw error
  }
}

export const getTurkeyBlogBySlug = async (slug, locale = 'en') => {
  try {
    const res = await api.get(`/Turkey/blog/${slug}`, {
      headers: { locale }
    })

    return res.data
  } catch (error) {
    console.error('Failed to fetch Turkey blog detail', error)
    throw error
  }
}

export const getTurkeyDocuments = async (locale = 'en') => {
  try {
    const response = await api.get('/Turkey/docs', {
        headers:{
            locale
        }
    })
    return response.data.data
  } catch (error) {
    console.error('Failed to fetch Turkey documents', error)
    throw error
  }
}

export const getTurkeyStages = async (locale = 'en') => {
  try {
    const response = await api.get('/Turkey/stages', {
        headers:{
            locale
        }
    })
    return response.data.data
  } catch (error) {
    console.error('Failed to fetch Turkey stages', error)
    throw error
  }
}

export const getTurkeyMedia = async (locale = 'en') => {
  try {
    const response = await api.get('/Turkey/social', {
        headers:{
            locale
        }
    })
    return response.data.data
  } catch (error) {
    console.error('Failed to fetch Turkey social media', error)
    throw error
  }
}

//service categories
export const getServiceCategories = async (locale = 'en') => {
  try {
    const response = await api.get('/categories', {
        hideLoader: true,
        headers:{
            locale
        }
    })
    return response.data.data
  } catch (error) {
    console.error('Failed to fetch service categories', error)
    throw error
  }
}

export const getServiceByCategoryId = async (categoryId ,locale = 'en') => {
  try {
    const response = await api.get(`/categories/${categoryId}/services`, {
        hideLoader: true,
        headers:{
            locale
        }
    })
    return response.data.data
  } catch (error) {
    console.error('Failed to fetch services', error)
    throw error
  }
}
